import * as React from "react"
import Svg, { Rect, G, Path, Defs, ClipPath, SvgProps } from "react-native-svg"

function VoltIconProps(props: SvgProps) {
    return (
        <Svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            {...props}
        >
            <Rect width={40} height={40} rx={6.66667} fill="#EBF2FF" />
            <G clipPath="url(#clip0_3150_4317)" fillRule="evenodd" clipRule="evenodd">
                <Path
                    d="M34.186 8.675C34.624 7.932 34.082 7 33.211 7h-3.138l-9.998 17.018-5.444-9.143a2.263 2.263 0 00-1.946-1.1h-3.81l11.136 18.92 14.175-24.02z"
                    fill="#1434CB"
                />
                <Path
                    d="M18.445 20.828L26.18 8.083A2.264 2.264 0 0128.117 7h1.74l-9.78 16.617-1.632-2.789zM19.708 32.692L8.575 13.8H7.142c-.873 0-1.415.936-.973 1.679l9.605 16.116a2.263 2.263 0 001.946 1.098h1.988z"
                    fill="#A1AEEA"
                />
            </G>
            <Defs>
                <ClipPath id="clip0_3150_4317">
                    <Path
                        fill="#fff"
                        transform="translate(6.012 7)"
                        d="M0 0H28.2057V26.0022H0z"
                    />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default VoltIconProps
